import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const downloadPagosSlice = createSlice({
  name: 'downloadPagos',
  initialState: {
    rows: []
  },
  reducers: {
    setPagosToDownload: (state, action) => {
      state.rows = action.payload;
    }
  }
});

export const { setPagosToDownload } = downloadPagosSlice.actions;

// Action Creators
export const downloadPagos = (comunidadId, anno, mes) => async (dispatch, getState) => {
  let item = LocalCache.get(`KEY:download-pagos&comunidad=${comunidadId}&ano=${anno}&mes=${mes}`);
  if (item) {
    dispatch(setPagosToDownload(item));
  } else {
    try {
      const response = await API.get('ePlat', `/download-pagos?comunidad=${comunidadId}&ano=${anno}&mes=${mes}`);
      dispatch(setPagosToDownload(response));
      LocalCache.put(`KEY:download-pagos&comunidad=${comunidadId}&ano=${anno}&mes=${mes}`, response);
    } catch (error) {
      console.log('DVD: ERROR Llamada a downloadPagos()', error);
    }
  }
};

export default downloadPagosSlice.reducer;
